export default __webpack_public_path__ + "static/Dachser-logo-07446cc7a3c406a2902e9f281e82770f.svg";